module.exports = __webpack_public_path__ + "static/media/card.dc2ff664.svg";